import * as api from '../api';
import { Map } from 'immutable';
import {action as toggleMenu} from 'redux-burger-menu';

const ACTIONS = {
  LOGIN_FORM_SUBMITTING: 'Snapit::LoginForm::Submitting',
  LOGIN_FORM_SUCCESS: 'Snapit::LoginForm::Success',
  LOGIN_FORM_FAILURE: 'Snapit::LoginForm::Failure',
  CODE_LOGIN_FORM_SUBMITTING: 'Snapit::CodeLoginForm::Submitting',
  CODE_LOGIN_FORM_SUCCESS: 'Snapit::CodeLoginForm::Success',
  CODE_LOGIN_FORM_FAILURE: 'Snapit::CodeLoginForm::Failure',
  ADD_DRAFT_ITEM_IMAGE: 'Snapit::AddDraftItemImage',
  CLEAR_DRAFT_ITEM_IMAGE: 'Snapit::ClearDraftItemImage',
  ADD_DRAFT_ITEM_CATEGORY_ID: 'Snapit::AddDraftItemCategoryId',
  ADD_DRAFT_ITEM_CATEGORY_NAME: 'Snapit::AddDraftItemCategoryName',
  EDIT_ITEM_CATEGORY_ID: 'Snapit::EditItemCategoryId',
  EDIT_ITEM_CATEGORY_NAME: 'Snapit::EditItemCategoryName',
  CLEAR_DRAFT_ITEM_CATEGORY_ID: 'Snapit::ClearDraftCategoryId',
  ADD_DRAFT_ITEM_VENUE_ID: 'Snapit::AddDraftItemVenueId',
  SNAP_FORM_SUBMITTING: 'Snapit::SnapForm::Submitting',
  SNAP_FORM_SUCCESS: 'Snapit::SnapForm::Success',
  SNAP_FORM_FAILURE: 'Snapit::SnapForm::Failure',
  CLEAR_DRAFT_ITEM: 'Snapit::ClearDraftItem',
  ADD_DRAFT_ITEM_VENUE_PERMALINK: 'Snapit::AddDraftItemVenuePermalink',
  SET_CHANGING_CATEGORY: 'Snapit::SetChangingCategory',
  FETCHING_ITEMS: 'Snapit::FetchingItems',
  FETCHED_ITEMS_SUCCESS: 'Snapit::FetchedItemsSuccess',
  FETCHED_ITEMS_FAILURE: 'Snapit::FetchedItemsFailure',
  SYNCING_ITEM_PROPS: 'Snapit::SyncingItemProps',
  SYNC_ITEM_PROPS_SUCCESS: 'Snapit::SyncItemPropsSuccess',
  SYNC_ITEM_PROPS_FAILURE: 'Snapit::SyncItemPropsFailure',
  DELETING_ITEM: 'Snapit::DeletingItem',
  DELETE_ITEM_SUCCESS: 'Snapit::DeleteItemSuccess',
  DELETE_ITEM_FAILURE: 'Snapit::DeleteItemFailure',
  ADD_PENDING_SNAP: 'Snapit::AddPendingSnap',
  CLEAR_DRAFT_ITEM_NAME: 'Snapit::ClearDraftItemName'
};

export const clearDraftItemName = () => ({type: ACTIONS.CLEAR_DRAFT_ITEM_NAME
})


export const addPendingSnap = (props) => ({type: ACTIONS.ADD_PENDING_SNAP,
  props
})

export const editItemCategoryId = (item_id, category_id) => ({type: ACTIONS.EDIT_ITEM_CATEGORY_ID,
  item_id,
  category_id
})

export const editItemCategoryName = (item_id, name) => ({type: ACTIONS.EDIT_ITEM_CATEGORY_NAME,
  item_id,
  name
})

export const setChangingCategory = (true_or_false) => ({type: ACTIONS.SET_CHANGING_CATEGORY,
   true_or_false
})

export const addDraftItemVenuePermalink = (venue_permalink) => ({
  type: ACTIONS.ADD_DRAFT_ITEM_VENUE_PERMALINK,
  venue_permalink
})

export const clearDraftItem = () => ({
  type: ACTIONS.CLEAR_DRAFT_ITEM
})

export const addDraftItemCategoryName = (name) => ({
  type: ACTIONS.ADD_DRAFT_ITEM_CATEGORY_NAME,
  name
})

export const addDraftItemVenueId = (id) => ({
  type: ACTIONS.ADD_DRAFT_ITEM_VENUE_ID,
  id
});

export const clearDraftItemCategoryId = () => ({
  type: ACTIONS.CLEAR_DRAFT_ITEM_CATEGORY_ID
})

export const addDraftItemCategoryId = (id) => ({
  type: ACTIONS.ADD_DRAFT_ITEM_CATEGORY_ID,
  id
})

export const addDraftItemImage = (image) => ({
  type: ACTIONS.ADD_DRAFT_ITEM_IMAGE,
  image
});

export const clearDraftItemImage = () => ({
  type: ACTIONS.CLEAR_DRAFT_ITEM_IMAGE
})


const fetchItems = (response, dispatch) => {

  // Let the state know the fetch is in-progress
  dispatch({
    type: ACTIONS.FETCHING_ITEMS
  });

  const user = new Map(response.entities.users[response.result.user]);
  const venue_permalink = user.getIn(["venues"])[0]["permalink"];
  const api_token = user.get("api_token");
  const account_subdomain = response.entities.users[response.result.user].account.subdomain;

  return api.getItems({account_subdomain,api_token,venue_permalink})
  .then((response) => {
    dispatch({
      type: ACTIONS.FETCHED_ITEMS_SUCCESS,
      response
    });
  })
  .catch((error) => {
    dispatch({
      type: ACTIONS.FETCHED_ITEMS_FAILURE,
      error
    })
  });
}

export const submitLoginForm = (email,password,udid) => (dispatch, getState) => {

  // Let the state know the submit is in-progress
  dispatch({
    type: ACTIONS.LOGIN_FORM_SUBMITTING
  });

  // Call the API with the comment, which will return a Promise.
  return api.loginCurrentUser({email,password, udid})
  .then((response) => {
    dispatch({
      type: ACTIONS.LOGIN_FORM_SUCCESS,
      response,
    });

    dispatch(toggleMenu(false));

    fetchItems(response,dispatch);

  })
  .catch((error) => {

    alert("Login Failed. Please check your entries and try again.")
    dispatch({
      type: ACTIONS.LOGIN_FORM_FAILURE,
      error
    })

  });
};


export const submitCodeLoginForm = (pin,udid) => (dispatch, getState) => {

  // Let the state know the submit is in-progress
  dispatch({
    type: ACTIONS.CODE_LOGIN_FORM_SUBMITTING
  });

  // Call the API with the comment, which will return a Promise.
  return api.updateCurrentUser({pin, udid})
  .then((response) => {

    dispatch({
      type: ACTIONS.CODE_LOGIN_FORM_SUCCESS,
      response,
    });

    dispatch(toggleMenu(false));

    fetchItems(response,dispatch);

  })
  .catch((error) => {

    alert("Login Failed. Please check your code and try again.")
    dispatch({
      type: ACTIONS.CODE_LOGIN_FORM_FAILURE,
      error
    })

  });
};


export const getItems = (api_token,venue_permalink,account_subdomain) => (dispatch, getState) => {

  // Let the state know the fetch is in-progress
  dispatch({
    type: ACTIONS.FETCHING_ITEMS
  });

  // Call the API with the comment, which will return a Promise.
  return api.getItems({api_token,venue_permalink,account_subdomain})
  .then((response) => {
    dispatch({
      type: ACTIONS.FETCHED_ITEMS_SUCCESS,
      response,
    });
  })
  .catch((error) => {
    dispatch({
      type: ACTIONS.FETCHED_ITEMS_FAILURE,
      error
    })
  });
};

//api_token,venue_permalink,account_subdomain,ownProps.item_id,{category_id:ownProps.id}

export const syncItemProps = (api_token,venue_permalink,account_subdomain,item_id,props)  => (dispatch, getState) => {

  // Let the state know the submit is in-progress
  dispatch({
    type: ACTIONS.SYNCING_ITEM_PROPS
  });

  // Call the API with the comment, which will return a Promise.
  return api.syncItemProps(api_token,venue_permalink,account_subdomain,item_id,props)
  .then((response) => {
    dispatch({
      type: ACTIONS.SYNC_ITEM_PROPS_SUCCESS,
      response,
    });
  })
  .catch((error) => {

    //alert("Login Failed. Please check your entries and try again.")
    dispatch({
      type: ACTIONS.SYNC_ITEM_PROPS_FAILURE,
      error
    })

  });
};



// Thunk to submit a comment for a venture's step
export const submitSnapForm = (name,description,internal_notes,category_id,venue_id,image,api_token,venue_permalink,account_subdomain,pending_id) => (dispatch, getState) => {

  // Let the state know the submit is in-progress
  dispatch({
    type: ACTIONS.SNAP_FORM_SUBMITTING
  });

  // Call the API with the comment, which will return a Promise.
  return api.submitSnap({name,description,internal_notes,category_id,venue_id,image,api_token,venue_permalink,account_subdomain,pending_id})
  .then((response) => {
    dispatch({
      type: ACTIONS.SNAP_FORM_SUCCESS,
      response,
    });
    dispatch({
      type: ACTIONS.CLEAR_DRAFT_ITEM
    });
  })
  .catch((error) => {

    //alert("Login Failed. Please check your entries and try again.")
    dispatch({
      type: ACTIONS.SNAP_FORM_FAILURE,
      error
    });

    const retry = submitSnapForm(name,description,internal_notes,category_id,venue_id,image,api_token,venue_permalink,account_subdomain,pending_id);

    setTimeout(function(){
      retry(dispatch, getState);
    }, 20000);

  });
};



// Thunk to submit a comment for a venture's step
export const deleteItem = (api_token,venue_permalink,account_subdomain,item_id) => (dispatch, getState) => {

  // Let the state know the submit is in-progress
  dispatch({
    type: ACTIONS.DELETING_ITEM,
    item_id
  });

  // Call the API with the comment, which will return a Promise.
  return api.deleteItem(api_token,venue_permalink,account_subdomain,item_id)
  .then((response) => {
    dispatch({
      type: ACTIONS.DELETE_ITEM_SUCCESS,
      response,
    });
  })
  .catch((error) => {

    //alert("Login Failed. Please check your entries and try again.")
    dispatch({
      type: ACTIONS.DELETE_ITEM_FAILURE,
      error
    })

  });
};


export default ACTIONS;



// WEBPACK FOOTER //
// ./src/snapit_app/actions/index.js